import { apiFetch } from '@/lib/api-client';
import type { EntitlementResult } from '@/hooks/useEntitlement';

/**
 * Raw, **uncached** fetch of `GET /api/credits/entitlement`. Distinct
 * from `useEntitlement()` (which caches at module level for the
 * Builder gate) — D-10 polling needs a fresh response each tick to
 * detect state-transitions (subscription provisioning + pack credit
 * grants) driven by Stripe webhooks landing post-checkout.
 *
 * Endpoint contract (Phase 2J.X, src/credits/dto/entitlement-result.dto.ts):
 *   - hasEntitlement: boolean
 *   - subscriptionRemaining: number
 *   - subscriptionPeriodEnd: ISO string | null
 *   - packRemaining: number
 *   - trialRemaining: number
 *
 * "Zero side effects — safe to poll." (endpoint JSDoc)
 */
export function fetchEntitlement(): Promise<EntitlementResult> {
  return apiFetch<EntitlementResult>('/api/credits/entitlement');
}
